export default __webpack_public_path__ + "static/media/ISCO CLASS-6 EXAM PATTERN 2025.fecdf0ce.pdf";